// @flow

import * as React from "react";

import { Error401Page } from "tabler-react";

type Props = {||};

function Error401(props: Props): React.Node {
  return <Error401Page action="Retry to login" redirect="/login" />;
}

export default Error401;
